'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ToastService = function () {
  function ToastService($log, $mdToast) {
    'ngInject';

    _classCallCheck(this, ToastService);

    Object.assign(this, {
      $log: $log,
      $mdToast: $mdToast
    });

    this.duration = 3000;
  }

  _createClass(ToastService, [{
    key: 'showError',
    value: function showError(error, message) {
      this.$log.error(error);

      this.$mdToast.show(this.$mdToast.simple().textContent(message && message.length ? message : 'Error! Something went wrong!').hideDelay(this.duration).toastClass('error').position('bottom right'));
    }
  }, {
    key: 'showWarning',
    value: function showWarning(message) {
      this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(this.duration).toastClass('error').position('bottom right'));
    }
  }, {
    key: 'showSuccess',
    value: function showSuccess(message, opts) {
      this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(opts && opts.duration ? opts.duration : this.duration).toastClass('success').position('bottom right'));
    }
  }]);

  return ToastService;
}();

exports.default = ToastService;


// WEBPACK FOOTER //
// ./services/toast.service.js